var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1336_27292)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.20396 15.0279C5.78216 14.4072 4.95996 13.2849 3.83766 12.1625C2.71548 11.0404 1.5933 10.2182 0.972496 9.79639C0.857616 9.95055 0.780649 10.1294 0.757909 10.3224C0.685149 10.94 0.590106 12.3188 0.769086 14.6295C0.793939 14.9504 1.05001 15.2065 1.37087 15.2313C3.68156 15.4103 5.06039 15.3152 5.67799 15.2425C5.87103 15.2197 6.04979 15.1428 6.20396 15.0279Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3689 6.88123C15.3381 5.912 15.7074 4.49503 14.8849 3.39857C14.607 3.02801 14.2577 2.61763 13.82 2.1799C13.3823 1.74217 12.9719 1.39292 12.6013 1.11496C11.5048 0.2925 10.0879 0.661757 9.11866 1.63096L1.0936 9.65607C0.91229 9.83737 0.787909 10.0672 0.757909 10.3219C0.685149 10.9395 0.590106 12.3183 0.769086 14.629C0.769964 14.6404 0.771131 14.6516 0.772578 14.6628C0.77115 14.6517 0.769996 14.6406 0.769127 14.6294C0.590147 12.3187 0.68519 10.9398 0.75795 10.3222C0.78069 10.1292 0.857657 9.95039 0.972537 9.79622C1.59334 10.2181 2.71552 11.0402 3.8377 12.1624C4.95985 13.2845 5.78198 14.4067 6.20383 15.0275C6.25312 14.9908 6.2999 14.9502 6.34383 14.9063L14.3689 6.88123Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.69407 15.3099C2.52654 15.0651 2.21199 14.6397 1.78657 14.2142C1.36064 13.7883 0.934724 13.4735 0.690063 13.3062C0.706247 13.7079 0.731627 14.1484 0.768877 14.6293C0.79373 14.9501 1.0498 15.2062 1.37066 15.2311C1.85166 15.2683 2.29229 15.2937 2.69407 15.3099Z",
    fill: "#475569"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1336_27292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.4b5752b2ddb71cf92f4520fae2f08234.svg";
export { ForwardRef as ReactComponent };